module.exports = __webpack_public_path__ + "img/d20190727_2.1f8fdd65.jpg";